export default __webpack_public_path__ + "static/media/psy_logo.12b65ded.png";